<template>
  <svg width="42" height="42" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
      <filter x="-30%" y="-23.3%" width="160%" height="160%" filterUnits="objectBoundingBox" id="a">
        <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1" />
        <feOffset dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1" />
        <feColorMatrix
          values="0 0 0 0 0.356862745 0 0 0 0 0.356862745 0 0 0 0 0.356862745 0 0 0 0.25 0"
          in="shadowBlurOuter1"
        />
      </filter>
      <circle id="b" cx="15" cy="15" r="15" />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <g transform="translate(6 4)">
        <use fill="#000" filter="url(#a)" xlink:href="#b" />
        <circle stroke="#FFF" stroke-width="2" fill="#9F8054" cx="15" cy="15" r="16" />
      </g>
      <path
        d="M22.06 25.032c.47.426 1.066.686 1.697.743a1.759 1.759 0 1 1-3.393.004 2.956 2.956 0 0 0 1.697-.747Zm2.4-3.877a1.76 1.76 0 1 1-2.138 1.235 2.879 2.879 0 0 0 1.205-.38 2.85 2.85 0 0 0 .934-.855Zm-4.354.492c.303.272.66.477 1.048.602a2.925 2.925 0 0 0 .203 1.841 1.758 1.758 0 0 1-2.947-1.7 2.927 2.927 0 0 0 1.696-.743Zm1.981-3.93a1.76 1.76 0 1 1-.038 3.518 1.76 1.76 0 0 1 .038-3.518Zm-4.604.125a1.759 1.759 0 0 1 1.92.393 2.925 2.925 0 0 0 0 2.466 1.753 1.753 0 0 1-1.92.396 1.759 1.759 0 0 1 0-3.255Zm8.932-.072a1.757 1.757 0 0 1 0 3.4 2.858 2.858 0 0 0-1.489-1.098c.085-.398.087-.81.004-1.208a2.905 2.905 0 0 0 1.485-1.094Zm-3.924-2.565a1.76 1.76 0 0 1 3.049 1.76 1.736 1.736 0 0 1-1.08.82 2.935 2.935 0 0 0-2.137-1.231c-.13-.454-.07-.94.168-1.349Zm-3.264-.64a1.758 1.758 0 0 1 2.13.28 2.885 2.885 0 0 0-.207 1.846 2.917 2.917 0 0 0-.555.242c-.176.1-.34.219-.489.356a2.947 2.947 0 0 0-1.696-.739 1.757 1.757 0 0 1 .817-1.986Zm3.983-5.393a.586.586 0 1 1 .83.829 4.722 4.722 0 0 0-1.392 3.36v.141c-.211.112-.408.249-.586.408a2.925 2.925 0 0 0-4.802 2.872c-1.536.166-3.048-.287-4.26-1.207.703-1.67 2.097-2.99 3.924-3.48 1.6-.428 3.23-.14 4.58.674a5.88 5.88 0 0 1 1.706-3.597Z"
        fill="#FFF"
        fill-rule="nonzero"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconPoiWinery',
};
</script>

<style></style>
